<div class="intralinks-container email-container" loading-spin [isLoading]="loading" [loadingSize]="'small'">
    <ag-grid-angular class="ag-theme-balham" [columnDefs]="columnDefs" [rowData]="files" [gridOptions]="gridOptions"
        (cellContextMenu)="onContextMenu($event)" (contextmenu)="suppressDefaultContextMenu($event)"
        (gridReady)="onGridReady($event)" (displayedColumnsChanged)="onDisplayedColumnsChanged($event)"
        (rowClicked)="onSelectionChanged($event)">
    </ag-grid-angular>
    <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
</div>